import { useTranslation } from 'react-i18next';
import heroImage from '../assets/images/family.png';
import heroDecoration01 from '../assets/hero-decoration-01.svg';
import heroDecoration02 from '../assets/hero-decoration-02.svg';
import heroDecoration03 from '../assets/hero-decoration-03.svg';
import heroDecoration04 from '../assets/hero-decoration-04.svg';
import heroDecoration05 from '../assets/hero-decoration-05.svg';
import forestImage from '../assets/images/forest.png';

const Hero: React.FC = () => {
    const { t } = useTranslation();

    return (
            <div id="home" className="home-header">
                <div className="padding-bottom padding-small"></div>
                <div className="padding-global">
                    <div className="container-large">
                        <div className="header-component">
                            <div className="header-content-wrapper">
                                {/* Left Content */}
                                <div className="header-left-content-wrapper">
                                    <div className="padding-bottom padding-xxsmall"></div>
                                    {/* Product name — H1 as primary identity */}
                                    <h1
                                        className="heading-style-h1"
                                        style={{
                                            margin: 0,
                                            lineHeight: 1,
                                            fontFamily: "Nunito, 'Noto Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif",
                                        }}
                                    >
                                        {t('hero.productTitle')}
                                    </h1>
                                    <div className="padding-bottom padding-xsmall"></div>
                                    {/* Tagline — previously the H1, demoted to supporting line */}
                                    <p
                                        style={{
                                            fontFamily: "Nunito, 'Noto Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif",
                                            fontSize: 'clamp(20px, 1.8vw, 26px)',
                                            fontWeight: 600,
                                            color: '#0c1a40',
                                            margin: 0,
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        {t('hero.sproutlyTitle')}
                                    </p>
                                    <div className="padding-bottom padding-xxsmall"></div>
                                    <p className="text-size-medium">
                                        {t('hero.sproutlyDescription')}
                                    </p>
                                    <div className="padding-bottom padding-small"></div>
                                    <a href="#download" className="button w-button">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{marginRight: '8px', verticalAlign: 'middle'}}>
                                            <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                                        </svg>
                                        {t('hero.downloadButton')}
                                    </a>
                                </div>

                                {/* Right Content - Hero Image */}
                                <div className="header-right-content">
                                    <div className="header-image-wrapper">
                                        <img
                                            src={heroImage}
                                            loading="lazy"
                                            width="494"
                                            alt="Sproutly AI - Child Development"
                                            className="hero-main-image"
                                        />
                                        <img
                                            src={heroDecoration01}
                                            loading="lazy"
                                            alt=""
                                            className="header-image _01"
                                        />
                                        <img
                                            src={heroDecoration02}
                                            loading="lazy"
                                            alt=""
                                            className="header-image _02"
                                        />
                                        <img
                                            src={heroDecoration03}
                                            loading="lazy"
                                            alt=""
                                            className="header-image _03"
                                        />
                                        <img
                                            src={heroDecoration04}
                                            loading="lazy"
                                            alt=""
                                            className="header-image _04"
                                        />
                                        <img
                                            src={heroDecoration05}
                                            loading="lazy"
                                            alt=""
                                            className="header-image _05"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Static forest background decoration at bottom */}
                <div className="header-tricker-content-wrapper">
                    <div className="header-inner-image-wrapper">
                        <img
                            src={forestImage}
                            loading="lazy"
                            alt=""
                            className="tricker-bg"
                        />
                    </div>
                </div>
            </div>
    );
};

export default Hero;
